import { useRouteMatch } from 'react-router-dom'

export const useProjectId = () => {
  const match = useRouteMatch('/projects/:projectId')
  return match?.params?.projectId
}
